import { SvgIcon } from "@material-ui/core";

export const ListIcon = (props) => {
  return (
    <SvgIcon
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M17.2924 8.799L13.0823 4.39328L14.7592 2.63846L17.2805 5.27691L22.3231 0L24 1.75482L17.2924 8.799ZM10.7037 3.82078H0V6.30989H10.7037V3.82078ZM22.5966 11.7984L20.9197 10.0436L17.8394 13.267L14.7592 10.0436L13.0823 11.7984L16.1625 15.0218L13.0823 18.2452L14.7592 20L17.8394 16.7766L20.9197 20L22.5966 18.2452L19.5164 15.0218L22.5966 11.7984ZM10.7037 13.7772H0V16.2663H10.7037V13.7772Z" />
    </SvgIcon>
  );
};

export const FileCheckedIcon = (props) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8.82 13.05L7.4 14.46L10.94 18L16.6 12.34L15.19 10.93L10.95 15.17L8.82 13.05Z"
        fill="#757575"
      />
    </SvgIcon>
  );
};

export const PaperIcon = (props) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.5 2.0102C20.3772 2.0102 20.2544 2.06122 20.1694 2.16327L19.4233 2.96939C19.2344 3.17347 18.9417 3.17347 18.7528 2.96939L18.0067 2.16327C17.8178 1.95918 17.525 1.95918 17.3361 2.16327L16.59 2.96939C16.4011 3.17347 16.1083 3.17347 15.9194 2.96939L15.1733 2.16327C14.9844 1.95918 14.6917 1.95918 14.5028 2.16327L13.7567 2.96939C13.5678 3.17347 13.275 3.17347 13.0861 2.96939L12.34 2.16327C12.1511 1.95918 11.8583 1.95918 11.6694 2.16327L10.9233 2.96939C10.7344 3.17347 10.4417 3.17347 10.2528 2.96939L9.49722 2.15306C9.30833 1.94898 9.01556 1.94898 8.82667 2.15306L8.08056 2.96939C7.89167 3.17347 7.59889 3.17347 7.41 2.96939L6.66389 2.15306C6.475 1.94898 6.18222 1.94898 5.99333 2.15306L5.24722 2.96939C5.05833 3.17347 4.76556 3.17347 4.57667 2.96939L3.83056 2.15306C3.74556 2.06122 3.62278 2.0102 3.5 2.0102V22C3.62278 22 3.74556 21.949 3.83056 21.8469L4.57667 21.0408C4.76556 20.8367 5.05833 20.8367 5.24722 21.0408L5.99333 21.8469C6.18222 22.051 6.475 22.051 6.66389 21.8469L7.41 21.0408C7.59889 20.8367 7.89167 20.8367 8.08056 21.0408L8.82667 21.8469C9.01556 22.051 9.30833 22.051 9.49722 21.8469L10.2433 21.0408C10.4322 20.8367 10.725 20.8367 10.9139 21.0408L11.66 21.8469C11.8489 22.051 12.1417 22.051 12.3306 21.8469L13.0767 21.0408C13.2656 20.8367 13.5583 20.8367 13.7472 21.0408L14.4933 21.8469C14.6822 22.051 14.975 22.051 15.1639 21.8469L15.91 21.0408C16.0989 20.8367 16.3917 20.8367 16.5806 21.0408L17.3267 21.8469C17.5156 22.051 17.8083 22.051 17.9972 21.8469L18.7433 21.0408C18.9322 20.8367 19.225 20.8367 19.4139 21.0408L20.16 21.8469C20.2544 21.949 20.3772 22 20.4906 22V2.0102H20.5ZM16.7222 17.102H7.27778C6.75833 17.102 6.33333 16.6429 6.33333 16.0816C6.33333 15.5204 6.75833 15.0612 7.27778 15.0612H16.7222C17.2417 15.0612 17.6667 15.5204 17.6667 16.0816C17.6667 16.6429 17.2417 17.102 16.7222 17.102ZM16.7222 13.0204H7.27778C6.75833 13.0204 6.33333 12.5612 6.33333 12C6.33333 11.4388 6.75833 10.9796 7.27778 10.9796H16.7222C17.2417 10.9796 17.6667 11.4388 17.6667 12C17.6667 12.5612 17.2417 13.0204 16.7222 13.0204ZM16.7222 8.93878H7.27778C6.75833 8.93878 6.33333 8.47959 6.33333 7.91837C6.33333 7.35714 6.75833 6.89796 7.27778 6.89796H16.7222C17.2417 6.89796 17.6667 7.35714 17.6667 7.91837C17.6667 8.47959 17.2417 8.93878 16.7222 8.93878Z"
        fill="#757575"
      />
    </SvgIcon>
  );
};

export const RubkOrcamentoIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM15.1213 13.3104C16.0454 13.9257 16.767 14.7999 17.1955 15.8234L15.1576 17.8058L14.5983 16.8394C14.4419 16.5206 14.2356 16.2288 13.9873 15.9749C13.6046 15.5927 13.117 15.3325 12.5863 15.2271C12.0555 15.1217 11.5054 15.1759 11.0054 15.3828C10.5055 15.5897 10.0782 15.94 9.77757 16.3894C9.47693 16.8389 9.31648 17.3673 9.31648 17.9078C9.31648 18.4483 9.47693 18.9767 9.77757 19.4261C10.0782 19.8756 10.5055 20.2259 11.0054 20.4328C11.5054 20.6397 12.0555 20.6938 12.5863 20.5884C13.117 20.483 13.6046 20.2228 13.9873 19.8407L17.4499 16.382L21.5236 12.3131H25.6L19.0311 18.8249L21.7801 23.5542H18.4678L16.9403 20.909L16.1258 21.7226L15.8714 21.9767L15.7693 22.0787C14.7217 22.9841 13.3864 23.4889 12.0012 23.5032C11.265 23.5053 10.5357 23.3621 9.85519 23.0816C9.17467 22.8012 8.55636 22.3892 8.03582 21.8693C7.51528 21.3493 7.10278 20.7317 6.82205 20.052C6.54131 19.3723 6.39789 18.6438 6.40001 17.9085V11.2963L9.25162 8.448V13.077C10.0904 12.6044 11.0382 12.3588 12.0012 12.3647C13.1118 12.3661 14.1972 12.695 15.1213 13.3104Z"
        fill="#9AAF00"
      />
    </svg>
  );
};

export const RubkFaturamentoIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM15.1213 13.3104C16.0454 13.9257 16.767 14.7999 17.1955 15.8234L15.1576 17.8058L14.5983 16.8394C14.4419 16.5206 14.2356 16.2288 13.9873 15.9749C13.6046 15.5927 13.117 15.3325 12.5863 15.2271C12.0555 15.1217 11.5054 15.1759 11.0054 15.3828C10.5055 15.5897 10.0782 15.94 9.77757 16.3894C9.47693 16.8389 9.31648 17.3673 9.31648 17.9078C9.31648 18.4483 9.47693 18.9767 9.77757 19.4261C10.0782 19.8756 10.5055 20.2259 11.0054 20.4328C11.5054 20.6397 12.0555 20.6938 12.5863 20.5884C13.117 20.483 13.6046 20.2228 13.9873 19.8407L17.4499 16.382L21.5236 12.3131H25.6L19.0311 18.8249L21.7801 23.5542H18.4678L16.9403 20.909L16.1258 21.7226L15.8714 21.9767L15.7693 22.0787C14.7217 22.9841 13.3864 23.4889 12.0012 23.5032C11.265 23.5053 10.5357 23.3621 9.85519 23.0816C9.17467 22.8012 8.55636 22.3892 8.03582 21.8693C7.51528 21.3493 7.10278 20.7317 6.82205 20.052C6.54131 19.3723 6.39789 18.6438 6.40001 17.9085V11.2963L9.25162 8.448V13.077C10.0904 12.6044 11.0382 12.3588 12.0012 12.3647C13.1118 12.3661 14.1972 12.695 15.1213 13.3104Z"
        fill="#5175B9"
      />
    </svg>
  );
};

export const UploadIcon = (props) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.00016 8.66667H7.00016V4.66667H9.66683L5.00016 0L0.333496 4.66667H3.00016V8.66667ZM0.333496 10H9.66683V11.3333H0.333496V10Z" />
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.2373 4H4.76857C4.08107 4 3.73732 4.8125 4.23732 5.28125L10.0186 11.0625V17.5C10.0186 17.75 10.1123 18 10.3311 18.125L12.8311 19.875C13.3311 20.2188 14.0186 19.875 14.0186 19.25V11.0625L19.7686 5.28125C20.2686 4.8125 19.9248 4 19.2373 4Z" />
    </svg>
  );
};

export const ExportIcon = (props) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13.3345 4.34336C13.3345 4.12459 13.2477 3.91276 13.0914 3.7565L9.69181 0.353428C9.53555 0.197165 9.32373 0.110352 9.10149 0.110352H8.88966V4.55518H13.3345V4.34336ZM19.8281 10.8057L16.5049 7.45821C16.1542 7.10749 15.5534 7.35403 15.5534 7.85061V10.1112H13.331V12.3336H15.5534V14.5977C15.5534 15.0943 16.1542 15.3408 16.5049 14.9901L19.8281 11.6391C20.0573 11.4099 20.0573 11.0349 19.8281 10.8057ZM6.66725 11.778V10.6668C6.66725 10.3612 6.91727 10.1112 7.22285 10.1112H13.3345V5.66639H8.61186C8.15349 5.66639 7.77845 5.29136 7.77845 4.83298V0.110352H0.833406C0.37156 0.110352 0 0.481912 0 0.943757V17.0563C0 17.5181 0.37156 17.8897 0.833406 17.8897H12.5011C12.9629 17.8897 13.3345 17.5181 13.3345 17.0563V12.3336H7.22285C6.91727 12.3336 6.66725 12.0836 6.66725 11.778Z" />
    </svg>
  );
};
